import type { AppendResult, PrefixCase, Switch } from './types'
import { getPrefixMatch } from './utils'

class ActionsSwitch implements Switch {
  protected cases: PrefixCase[] = []

  constructor() {
    this.append = this.append.bind(this)
    this.case = this.case.bind(this)
    this.run = this.run.bind(this)
  }

  append(matcher: ActionsSwitch): AppendResult {
    this.cases.push(...matcher.cases)
    return this
  }

  case(prefix: string[], action: (...args: string[]) => void) {
    this.cases.push({ action, prefix })
    return this
  }

  run(keys: string[]) {
    for (const { action, prefix } of this.cases) {
      const [matched, args] = getPrefixMatch(keys, ...prefix)
      if (matched) {
        action(...args)
        return
      }
    }
  }
}

export const createSwitch = (): Switch => new ActionsSwitch()
